<template>
    <section class="lymphomap_main">
        <div class="create_meeting_wrp">
            <div class="row align-items-center">
                <div class="col-sm">
                    <h2 class="main_heading">
                        <button type="button" class="btn back_btn" tapable @click="$router.go(-1)">
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </button>Meetings
                    </h2>
                </div>
                <div class="col-md-9 mt-3 mt-md-0">
                    <div class="row">
                        <div class="col-md pl-md-0 filter_field_form">
                            <div class="dropdown custom_select_dropdown">
                                <div id="typeModelFilter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="form_control">
                                    <template v-if="!filterType">Please Select</template>
                                    <template v-else>{{ filterType }}</template>
                                </div>
                                <div aria-labelledby="typeModelFilter" class="dropdown-menu" style="height:72px;">
                                    <div class="dropdown-menuin">
                                        <ul>
                                            <li class="dropdown-item" @click="filterByKeyMethod('upcoming')">Upcoming</li>
                                            <li class="dropdown-item" @click="filterByKeyMethod('past')">Past</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md pl-md-0 filter_field_form">
                            <div class="dropdown custom_select_dropdown">
                                <div id="yearModelFilter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="form_control">
                                    <template v-if="!yearState">Please Select</template>
                                    <template v-else>{{ yearState }}</template>
                                </div>
                                <div aria-labelledby="yearModelFilter" class="dropdown-menu" style="height:72px;">
                                    <div class="dropdown-menuin">
                                        <ul>
                                            <li v-for="year in ['2021', '2022', '2023', '2024', '2025', '2026']" :key="year" class="dropdown-item" @click="filterByYearMethod(year)">{{ year }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md pl-md-0 filter_field_form">
                            <div class="dropdown custom_select_dropdown">
                                <div id="monthModelFilter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="form_control">
                                    <template v-if="!monthState">Please Select</template>
                                    <template v-else>{{ monthState }}</template>
                                </div>
                                <div aria-labelledby="monthModelFilter" class="dropdown-menu" style="height:72px;">
                                    <div class="dropdown-menuin">
                                        <ul>
                                            <li class="dropdown-item" @click="filterByMonthMethod('January', '1')">January</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('February', '2')">February</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('March', '3')">March</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('April', '4')">April</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('May', '5')">May</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('June', '6')">June</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('July', '7')">July</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('August', '8')">August</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('September', '9')">September</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('October', '10')">October</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('November', '11')">November</li>
                                            <li class="dropdown-item" @click="filterByMonthMethod('December', '12')">December</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-auto pl-md-0 filter_field_form" v-if="filterEnabledState">
                            <button class="btn btn-danger clear-filter-btn" @click="clearFiltersMethod">Clear Filters</button>
                        </div>

                        <div class="col-md-auto pl-md-0">
                            <router-link :to="'/video/conference/#' + StaticUUID" class="btn btn-primary create_meeting_btn mr-3" v-if="staffUserCheck">Staff Meeting</router-link>
                            <button class="btn btn-primary create_meeting_btn" @click="handleCreateMeetingClick">Create Meeting</button>
                            <router-link :to="{ name: 'deletedMeetingList' }" class="btn btn-danger ml-3 deleted_meeting_tooltip_box">
                                <i class="fa fa-trash"></i>
                                <span class="deleted_meeting_tooltip"><span>Deleted Meetings</span></span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mbl_table_list_view" v-if="isMobile">
                <div class="table_list_inner_wrp" v-if="meetingListDetails">
                    <div class="table_list_inner_box" v-if="hasMeetings">
                        <div class="table_list_row_item" v-for="(itemsList, rowIndex) in meetingListResults" :key="rowIndex">
                            <div class="table_list_item" v-for="(item_val, itemKey) in itemsList" :key="itemKey">
                                <div class="card table_item_card" v-for="item in item_val" :key="item.id">
                                    <div class="row">
                                        <div class="col">
                                            <h3 class="mbl_meeting_topic">{{ item.topic }}</h3>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h5 class="mbl_meeting_speaker">{{ itemKey | LocalDateFormat }}</h5>
                                            <h6 class="mbl_meeting_date">{{ item.start_time | LocalTimeFormat }} To {{ item.end_time | LocalTimeFormat }}</h6>
                                        </div>
                                        <div class="col-auto copied_url_btn_wrp mt-2">
                                            <template v-if="item.is_public">
                                                <button v-if="statusCheckOfMeetingMethod(item.end_time) || enabledJoinBtn(item.start_time, item.end_time)" class="btn btn-primary" @click="urlClipBoardMethod(item.id)">Copy URL</button>
                                                <button v-else class="btn btn-secondary" style="cursor:not-allowed;" disabled>URL Expired</button>
                                            </template>
                                            <template v-else>-</template>
                                            <i v-if="statusCheckOfMeetingMethod(item.end_time)" class="fa fa-bell" aria-hidden="true" @click="userReminderForMeetingMethod(item)"></i>
                                        </div>
                                    </div>
                                    <div class="row align-items-center mt-3">
                                        <div class="col">
                                            <router-link :to="'/conference/#' + item.id" class="btn btn-success member_user_video_call_btn" v-if="enabledJoinBtn(item.start_time, item.end_time)">
                                                <svg version="1.1" width="39" height="39" viewBox="0 0 452 452"><g><path d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0" fill="#0aefea"></path><path d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0" fill="#0aefea"></path></g></svg>
                                            </router-link>
                                            <button class="btn btn-success member_user_video_call_btn" v-else disabled>
                                                <svg version="1.1" width="39" height="39" viewBox="0 0 452 452"><g><path d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0" fill="#0aefea"></path><path d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0" fill="#0aefea"></path></g></svg>
                                            </button>
                                        </div>
                                        <div class="col-auto">
                                            <span v-if="countdownTexts[item.id]" class="js-timeout">{{ countdownTexts[item.id] }}</span>
                                            <template v-else>
                                                <label class="user_status_badge badge badge-success" title="Active" v-if="enabledJoinBtn(item.start_time, item.end_time)"></label>
                                                <label class="user_status_badge badge badge-info" title="Upcoming" v-else-if="statusCheckOfMeetingMethod(item.end_time)"></label>
                                                <label class="user_status_badge badge badge-danger" title="Closed" v-else></label>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no_data_available" v-else>You don't have any webinar.</div>
                </div>
                <div class="fixloader" v-else>
                    <div class="spinner spinner-1"></div>
                </div>
            </div>

            <div class="top_brd pt-1 mt-4" v-else>
                <table class="table create_meeting_table_list meeting_main_table" v-if="meetingListDetails">
                    <thead>
                        <tr>
                            <th width="15%">Date</th>
                            <th width="85%">
                                <table class="table inner_table_styling">
                                    <tr>
                                        <th width="25%">Topic</th>
                                        <th width="15%">Start Time</th>
                                        <th width="13%">End Time</th>
                                        <th width="10%" class="text-center">Users</th>
                                        <th width="13%" class="text-center">Public <br> URL</th>
                                        <th width="13%" class="text-center">Join</th>
                                        <th width="12%" class="text-center">Active <br> Status</th>
                                        <th width="8%" class="text-center">Action</th>
                                    </tr>
                                </table>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="hasMeetings">
                        <tr>
                            <td colspan="2" width="100%" class="meeting_list_body_wrp">
                                <table class="meeting_list_table" v-for="(itemsList, index) in meetingListResults" :key="index">
                                    <tr v-for="(item_val, itemKey) in itemsList" :key="itemKey">
                                        <td class="meeting_cell_date" width="15%">{{ itemKey | LocalDateFormat }}</td>
                                        <td class="meeting_values_table" :class="item_val.length > 1 ? 'brd_left_light' : ''" width="85%">
                                            <table class="table">
                                                <tbody>
                                                    <tr v-for="item in item_val" :key="item.id">
                                                        <td class="meeting_topic" width="25%">{{ item.topic }}</td>
                                                        <td width="15%" class="start_time">{{ item.start_time | LocalTimeFormat }}</td>
                                                        <td width="13%" class="end_time">{{ item.end_time | LocalTimeFormat }}</td>
                                                        <td class="user_list_name text-center" width="10%">
                                                            <span class="users_tooltip_wrp" v-if="item.users && item.users.length > 0">
                                                                <span>{{ item.users.length }}</span>
                                                                <ul class="users_tooltip_list">
                                                                    <li v-for="(userName, uIdx) in item.users" :key="uIdx">
                                                                        {{ userName.user.first_name }} {{ userName.user.last_name }}
                                                                    </li>
                                                                </ul>
                                                            </span>
                                                            <span v-else>0</span>
                                                        </td>
                                                        <td class="text-center webinar_url_info copied_url_btn_wrp" width="13%">
                                                            <template v-if="item.is_public">
                                                                <button v-if="statusCheckOfMeetingMethod(item.end_time) || enabledJoinBtn(item.start_time, item.end_time)" class="btn btn-primary" @click="urlClipBoardMethod(item.id)">Copy URL</button>
                                                                <button v-else class="btn btn-secondary" style="cursor:not-allowed;" disabled>URL Expired</button>
                                                            </template>
                                                            <template v-else>-</template>
                                                            <i v-if="statusCheckOfMeetingMethod(item.end_time)" class="fa fa-bell" aria-hidden="true" @click="userReminderForMeetingMethod(item)"></i>
                                                        </td>
                                                        <td width="13%" class="text-center">
                                                            <router-link :to="'/conference/#' + item.id" class="btn btn-success member_user_video_call_btn" v-if="enabledJoinBtn(item.start_time, item.end_time)">
                                                                <svg version="1.1" width="39" height="39" viewBox="0 0 452 452"><g><path d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0" fill="#0aefea"></path><path d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0" fill="#0aefea"></path></g></svg>
                                                            </router-link>
                                                            <button class="btn btn-success member_user_video_call_btn" v-else disabled>
                                                                <svg version="1.1" width="39" height="39" viewBox="0 0 452 452"><g><path d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0" fill="#0aefea"></path><path d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0" fill="#0aefea"></path></g></svg>
                                                            </button>
                                                        </td>
                                                        <td class="text-center" width="12%">
                                                            <span v-if="countdownTexts[item.id]" class="js-timeout">{{ countdownTexts[item.id] }}</span>
                                                            <template v-else>
                                                                <label class="user_status_badge badge badge-success" title="Active" v-if="enabledJoinBtn(item.start_time, item.end_time)"></label>
                                                                <label class="user_status_badge badge badge-info" title="Upcoming" v-else-if="statusCheckOfMeetingMethod(item.start_time)"></label>
                                                                <label class="user_status_badge badge badge-danger" title="Closed" v-else></label>
                                                            </template>
                                                        </td>
                                                        <td class="text-center" width="8%">
                                                            <div class="d-flex justify-content-center" v-if="item.created_by && item.created_by.id === selfUserId">
                                                                <span v-if="statusCheckOfMeetingMethod(item.start_time)" class="meeting_edit_icon"  @click="updateMeetingMethod(item.id)">
                                                                    <i class="fa fa-pencil"></i>
                                                                </span>
                                                                <span class="meeting_edit_icon remove_meeting_class" @click="removeMeetingMethod(item.id)">
                                                                    <i class="fa fa-trash"></i>
                                                                </span>
                                                            </div>
                                                            <template v-else>-</template>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        <tr v-if="nextPageUrl">
                            <td colspan="2" class="text-center pb-0" width="100%">
                                <button class="btn btn-default load_more_btn" @click="showLoadMoreDataMethod(nextPageUrl)">Load More</button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr class="text-center">
                            <td colspan="2" width="100%">You don't have any meetings.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="fixloader" v-else>
                    <div class="spinner spinner-1"></div>
                </div>
                <div class="fixloader userLoading meeting_list_loader" v-if="userLoading">
                    <div class="spinner spinner-1"></div>
                </div>
            </div>

            <edit-meeting :meetingID="editMeetingId" v-if="updateMeetingPopup"></edit-meeting>
            <create-meeting v-if="createMeetingPopup"></create-meeting>
            <thirty-days-trial-popup v-if="thirtyDaysTrialPopupState" :thirtyDaysTrialEnded="thirtyDaysTrialEnded"></thirty-days-trial-popup>
            <remove-meeting v-if="removeMeetingPopup" :removeMeetingID="removeMeetingId"></remove-meeting>
        </div>
        <access-feature-of-blurb v-if="accessFeaturesOfPackageState"></access-feature-of-blurb>
    </section>
</template>

<script>
import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import axios from 'axios';
import { bus } from '@/main';
import createMeetingInfoPopup from '@/components/private/meeting/create-meeting-info-popup';
import { mapGetters } from 'vuex';
import moment from 'moment';
import removeMeetingPopup from '@/components/private/meeting/meeting-remove-popup';
import root from '@/_helpers/roots';
import thirtyDaysTrial from '@/components/private/thirty-dats-trail-popup';
import toast from '@/services/toast';
import updateMeeting from '@/components/private/meeting/update-meeting-details';

let getAllMeetingListURL = root.getAllMeetingListUrl.link;

export default {
    name: 'create-meeting-list',
    components: {
        'edit-meeting': updateMeeting,
        'create-meeting': createMeetingInfoPopup,
        'remove-meeting': removeMeetingPopup,
        'access-feature-of-blurb': accessFeaturesForBlurb,
        'thirty-days-trial-popup': thirtyDaysTrial
    },
    data() {
        return {
            createMeetingPopup: false,
            meetingListDetails: null,
            curentDate: new Date(),
            currentUTCDate: '',
            selfUserId: '',
            editMeetingId: '',
            updateMeetingPopup: false,
            nextPageUrl: '',
            nextSteper: '',
            meetingListResults: [],
            userLoading: false,
            removeMeetingPopup: false,
            removeMeetingId: '',
            StaticUUID: '6d5e0cc3-a9d8-4f18-99dc-b5a45d194a52695872',
            accessFeaturesOfPackageState: false,
            filterType: '',
            yearState: '',
            monthState: '',
            monthStateVal: '',
            meetingCheckState: '',
            filterEnabledState: false,
            isMobile: false,
            thirtyDaysTrialButton: false,
            thirtyDaysTrialEnded: false,
            thirtyDaysTrialPopupState: false,
            
            // Reactive tracker to handle individual meeting timers inside the markup safely
            countdownTexts: {},
            timerIntervalId: null
        }
    },
    computed: {
        ...mapGetters([
            'selfUserInfoGetters',
            'getMeetingListGetters'
        ]),
        userProfileDetails() {
            return this.selfUserInfoGetters ? this.selfUserInfoGetters.data : null;
        },
        staffUserCheck() {
            return this.userProfileDetails ? this.userProfileDetails.is_staff : false;
        },
        pro_payment() {
            return this.userProfileDetails ? this.userProfileDetails.pro_payment : false;
        },
        auto_payment() {
            return this.userProfileDetails ? this.userProfileDetails.auto_payment : false;
        },
        hasMeetings() {
            return this.meetingListDetails && this.meetingListDetails.dates_arr && this.meetingListDetails.dates_arr.length > 0;
        }
    },
    watch: {
        getMeetingListGetters: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.data) {
                    this.meetingListDetails = newVal.data;
                    this.nextPageUrl = newVal.data.next;
                    this.nextSteper = newVal.data.next;
                    this.meetingListResults = [].concat(newVal.data.results);
                    this.initializeCountdownTimers();
                }
            }
        },
        nextSteper(newVal) {
            if (newVal) {
                this.nextPageUrl = newVal;
            }
        }
    },
    mounted() {
        this.domainLocationOrigin = window.location.origin;
        if (localStorage.getItem('LoginedUserID')) {
            this.selfUserId = localStorage.getItem('LoginedUserID');
        }

        bus.$on('updateMeetingStateBus', (data) => { this.updateMeetingPopup = data; });
        bus.$on('removeMeetingPopupBus', (data) => { this.removeMeetingPopup = data; });
        bus.$on('createMeetingPopupBus', (data) => {
            this.createMeetingPopup = data;
            if (!data) {
                this.thirtyDaysTrialEnded = false;
                this.thirtyDaysTrialButton = false;
                this.getThirtyDaysAccessInfoMethod();
            }
        });
        bus.$on('accessFeaturesOfPackageStateBus', (data) => { this.accessFeaturesOfPackageState = data; });
        bus.$on('thirtyDaysTrailPopupStateBus', (data) => { this.thirtyDaysTrialPopupState = data; });
        
        this.getThirtyDaysAccessInfoMethod();
        this.initializeCountdownTimers();
    },
    created() {
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        document.body.classList.remove('body_right_scroll_remove');
        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId);
        }
    },
    methods: {
        getThirtyDaysAccessInfoMethod() {
            this.$store.dispatch('getThirtyDaysTrailApiUrl').then((res) => {
                if (res.data && res.data.data && res.data.data.trial_start_datetime) {
                    if (res.data.data.current_datetime > res.data.data.trial_end_datetime) {
                        this.thirtyDaysTrialEnded = true;
                        this.thirtyDaysTrialButton = true;
                    }
                } else {
                    this.thirtyDaysTrialButton = true;
                }
            }).catch(() => {
                this.thirtyDaysTrialButton = true;
            });
        },
        handleCreateMeetingClick() {
            if (this.pro_payment || this.auto_payment) {
                this.openCreateMeetingPopup();
            } else if (this.thirtyDaysTrialButton) {
                this.meetingCreationForBlurbMethod();
            } else {
                this.openCreateMeetingPopup();
            }
        },
        meetingCreationForBlurbMethod() {
            this.thirtyDaysTrialPopupState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        onResize() {
            this.isMobile = window.innerWidth < 1023;
        },
        clearFiltersMethod() {
            this.filterEnabledState = false;
            this.filterType = '';
            this.monthState = '';
            this.monthStateVal = '';
            this.yearState = '';
            this.meetingCheckState = '';
            this.userLoading = true;
            this.$store.dispatch('getMeetingAllListFun').then(() => {
                this.userLoading = false;
            }).catch(() => {
                this.userLoading = false;
            });
        },
        filterByKeyMethod(val) {
            this.filterEnabledState = true;
            this.filterType = val;
            this.userLoading = true;
            this.meetingCheckState = (this.filterType === 'upcoming') ? 'True' : 'False';
            
            axios.get(`${getAllMeetingListURL}?is_webinar=False&page_size=15&upcoming=${this.meetingCheckState}&date_time=${moment(new Date()).format()}&year=${this.yearState}&month=${this.monthStateVal}`)
                .then((response) => {
                    this.updateMeetingListData(response.data.data);
                });
        },
        filterByYearMethod(val) {
            this.filterEnabledState = true;
            this.yearState = val;
            this.userLoading = true;
            
            axios.get(`${getAllMeetingListURL}?is_webinar=False&page_size=15&upcoming=${this.meetingCheckState}&year=${this.yearState}&month=${this.monthStateVal}`)
                .then((response) => {
                    this.updateMeetingListData(response.data.data);
                });
        },
        filterByMonthMethod(month, val) {
            this.filterEnabledState = true;
            this.monthState = month;
            this.monthStateVal = val;
            this.userLoading = true;
            this.filterType = '';
            const is_year = this.yearState || moment(new Date()).format('YYYY');
            
            axios.get(`${getAllMeetingListURL}?is_webinar=False&page_size=15&upcoming=${this.meetingCheckState}&year=${is_year}&month=${this.monthStateVal}`)
                .then((response) => {
                    this.updateMeetingListData(response.data.data);
                });
        },
        updateMeetingListData(data) {
            this.meetingListDetails = data;
            this.nextPageUrl = data.next;
            this.nextSteper = data.next;
            this.meetingListResults = [].concat(data.results);
            this.userLoading = false;
            this.initializeCountdownTimers();
        },
        userReminderForMeetingMethod(item) {
            this.$store.dispatch('meetingReminderAction', { id: item.id }).then((res) => {
                toast.success(res.data.msg);
            });
        },
        urlClipBoardMethod(value) {
            const copyUrl = `${this.domainLocationOrigin}/public/conference/#${value}`;
            navigator.clipboard.writeText(copyUrl);
        },
        showLoadMoreDataMethod(url) {
            this.userLoading = true;
            axios.get(url).then((response) => {
                this.nextSteper = response.data.data.next;
                this.meetingListResults = [].concat(response.data.data.results, this.meetingListResults);
                this.userLoading = false;
                this.initializeCountdownTimers();
            });
        },
        updateMeetingMethod(meetingId) {
            this.editMeetingId = meetingId;
            this.updateMeetingPopup = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        openCreateMeetingPopup() {
            this.createMeetingPopup = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        removeMeetingMethod(removeItemId) {
            this.removeMeetingPopup = true;
            this.removeMeetingId = removeItemId;
            document.body.classList.add('body_right_scroll_remove');
        },
        enabledJoinBtn(joinStartTime, joinEndTime) {
            const start = moment(joinStartTime).local();
            const end = moment(joinEndTime).local();
            const now = moment();
            return now.isAfter(start) && now.isBefore(end);
        },
        statusCheckOfMeetingMethod(endTime) {
            return moment(endTime).local().isAfter(moment());
        },
        initializeCountdownTimers() {
            if (this.timerIntervalId) {
                clearInterval(this.timerIntervalId);
            }

            const calculateAllTimers = () => {
                let updatedTexts = {};
                this.meetingListResults.forEach((group) => {
                    Object.keys(group).forEach((key) => {
                        const meetings = group[key];
                        if (Array.isArray(meetings)) {
                            meetings.forEach((meeting) => {
                                const timerStr = this.getMeetingCountdownString(meeting.start_time);
                                if (timerStr) {
                                    updatedTexts[meeting.id] = timerStr;
                                }
                            });
                        }
                    });
                });
                this.countdownTexts = updatedTexts;
            };

            calculateAllTimers();
            this.timerIntervalId = setInterval(calculateAllTimers, 1000);
        },
        getMeetingCountdownString(startTime) {
            const now = moment();
            const start = moment(startTime);
            
            if (start.isSame(now, 'day') && start.isAfter(now)) {
                const diffMinutes = start.diff(now, 'minutes');
                if (diffMinutes >= 0 && diffMinutes < 11) {
                    const diffSeconds = start.diff(now, 'seconds') % 60;
                    const displayMins = diffMinutes;
                    const displaySecs = diffSeconds < 10 ? '0' + diffSeconds : diffSeconds;
                    return `${displayMins}:${displaySecs}`;
                }
            }
            return null;
        }
    }
}
</script>
<style lang="scss" scoped>
.create_meeting_wrp {
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    letter-spacing: 1px;

    .top_brd {
        // background: rgba(228,233,237,.1);
        // padding: 10px;
        min-height: 80vh;
    }

    .table.meeting_main_table {
        margin-bottom: 0;
        letter-spacing: 0.5px;
        color: #ffffff;
        border-collapse: separate;
        border-spacing: 0 3px;

        >thead>tr {
            background: rgba(228, 233, 237, .1);
            align-items: end;
        }

        >thead tr {
            align-items: end;
        }

        >thead th {
            border-bottom: 0;
            font-size: 19px;
            padding: 10px 8px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            text-transform: uppercase;
            border-top: 0px;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            color: #87cefa;
            word-spacing: 5px;
        }

        >thead .empty_cell th {
            padding: 0px !important;
            background: none !important;
        }

        >tbody tr td {
            color: #ffffff;
            vertical-align: top;
            padding: 20px 8px;
            font-size: 20px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            border-top: 0px;
            background: rgba(228, 233, 237, .1);

            &.meeting_cell_date {
                color: #fff8d8;
            }
        }

        a:hover {
            text-decoration: none;
        }

        .member_user_avtaar {
            display: inline-block;
            vertical-align: middle;
            position: relative;

            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                cursor: pointer;
            }
        }

        .online-status {
            position: absolute;
            right: 4px;
            bottom: 2px;
            border: 1px solid #9E9E9E;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            background: #9E9E9E;

            &.online {
                background-color: #4CAF50;
                border-color: #4CAF50;
            }

            &.busy {
                background-color: #F44336;
                border-color: #F44336;
            }
        }

        .member_user_info {
            display: inline-block;
            vertical-align: middle;
            width: calc(100% - 70px);
            margin-left: 10px;
        }

        .member_user_name {
            line-height: 1;
            font-size: 20px;
            color: #fff;
            display: block;
            cursor: pointer;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;

            a {
                color: #ffffff;
                text-decoration: none;
            }
        }

        .member_join_date {
            line-height: 1;
            font-size: 16px;
            color: #fff;
            display: block;
        }

        .member_user_email,
        .member_join_time {
            font-size: 15px;
            color: hsla(0, 0%, 100%, .5);
            white-space: pre-wrap;
            word-break: break-all;
            display: block;
        }

        .country-flag {
            width: 45px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
            // height: 64px;
            object-fit: cover;
        }

        .country-flag-name {
            width: calc(100% - 55px);
            display: inline-block;
            vertical-align: middle;
            line-height: 1.2;
        }

        .btn-success.member_user_video_call_btn {
            padding: 5px;
            font-size: 18px;
            border-radius: 3px;
            background: rgba(255, 255, 255, 0.12);
            color: #ffd400;
            border: none;
            margin-right: 0px;
            text-transform: capitalize;
            font-weight: 400;
            letter-spacing: .03em;
            line-height: 1;
            box-shadow: none !important;
            min-width: 36px;
            height: 34px;

            &:disabled {
                cursor: not-allowed;
                opacity: .6;

                path {
                    fill: #689bba;
                }
            }

            &:hover path,
            &:focus path {
                fill: #000000;
            }

            &:hover,
            &:focus {
                background: #87cefa;
                color: #22292f;
                border-color: #87cefa;
            }
        }
    }

    .meeting_values_table {
        padding: 0px 8px !important;

        &.brd_left_light {
            border-left: 1px solid rgba(255, 255, 255, 0.1);
        }

        .table {
            margin: 0;

            tr {
                border-top: 1px solid rgba(255, 255, 255, 0.1);

                &:first-child {
                    border-top: 0px !important;
                }

                td {
                    padding: 10px 8px;
                    background: none !important;
                }
            }
        }
    }

    .table.inner_table_styling {
        margin: 0;

        th {
            background: none !important;
            padding: 0 8px !important;
        }
    }

    .main_heading {
        color: #ffffff;
        font-size: 24px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .btn-primary {
        cursor: pointer;
        box-shadow: none !important;
        outline: none !important;

        &:hover {
            background: #87cefa !important;
            color: #000 !important;
            border-color: #87cefa !important;
        }
    }

    .action_list {
        display: flex;
        margin: 0;
        justify-content: flex-end;

        li {
            margin-left: 10px;

            &:first-child {
                margin-left: 0px;
            }

            .btn {
                padding: 2px 8px;
            }
        }
    }

    .custom_round_switch {
        vertical-align: middle;
        margin-bottom: 0;
        margin-top: 3px;

        span {
            width: 20px;
            height: 20px;
            background: #da1b22;
            cursor: pointer;
            position: relative;
            display: inline-block;
            vertical-align: middle;
            border-radius: 50%;

            &:before {
                content: "";
                width: 10px;
                height: 10px;
                background: #fff;
                position: absolute;
                margin: auto;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                border-radius: 50%;
            }
        }
    }

    input[type=checkbox].checked+.custom_round_switch span {
        background: #36b04c;
    }

    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;
    }

    .load_more_btn:hover {
        color: #000 !important;
        background: #87cefa;
    }

    .user_event_info {
        margin-top: 15px;
        display: block;

        .btn-primary {
            padding: 7px 15px;
            font-size: 17px;
            border-radius: 70px;
            background: rgba(255, 255, 255, 0.12);
            color: #ffd400;
            border: none;
            margin-right: 5px;
            text-transform: capitalize;
            font-weight: 400;
            letter-spacing: .03em;
            line-height: 1;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;

            &:hover {
                background: #87cefa;
                color: #22292f;
            }
        }
    }

    .user_not_connected_popup h3 {
        font-size: 20px;
        letter-spacing: 0;
        text-align: center;
    }

    .user_not_connected_popup .remove_data_task_modal_body {
        padding: 50px 30px;
        margin: 0px auto;
        width: 500px;
        text-align: center;
    }

    .connected_user_info_popup {
        .remove_data_task_modal_body {
            width: 560px !important;
            position: relative;

            h3 {
                font-size: 22px;
                letter-spacing: 0;
                margin-bottom: 15px;
            }

            .connected_user_info_closed_icon {
                position: absolute;
                top: 5px;
                right: 8px;
                line-height: 1;

                .fa {
                    font-size: 20px;
                    color: red;
                    cursor: pointer;
                    transform: scale(1);
                    -webkit-transform: scale(1);
                    -moz-transform: scale(1);
                    transition: all ease 0.5s;

                    &:hover {
                        transform: scale(1.1);
                        -webkit-transform: scale(1.1);
                        -moz-transform: scale(1.1);
                    }
                }
            }
        }
    }

    .request_send_popup .form-control {
        background: rgba(255, 255, 255, 0.1) !important;
        border: none;
        color: #fff;
    }

    .request_send_popup h3 {
        font-size: 22px;
        letter-spacing: 0;
    }

    .badge {
        font-weight: normal;
        font-size: 16px;
        margin-bottom: 0px;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
        width: 20px;
        height: 20px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .request_send_popup .remove_data_task_modal_body {
        text-align: center;
    }

    .member_hosiptal {
        display: block;
        max-width: 180px;
    }

    .member_department {
        display: block;
        max-width: 110px;
    }

    .blank_val {
        font-size: 40px;
        line-height: 1;
    }

    .member_list_filters_wrp {
        padding: 12px 0;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        .total_count_box {
            background: rgba(228, 233, 237, 0.1);
            padding: 0px 25px 35px;
            border-radius: 5px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: flex-end;
            -ms-flex-align: flex-end;
            align-items: flex-end;
            cursor: pointer;
            color: #fff;
            height: 135px;

            &:hover {
                background: #87cefa;
                color: #000000;
            }

            &:hover .count_icon path {
                fill: #000000;
            }

            &:hover .count_icon span {
                background: rgba(0, 0, 0, 0.1)
            }

            &.active {
                background: #87cefa;
                color: #000000;
            }

            &.active .count_icon path {
                fill: #000000;
            }

            &.active .count_icon span {
                background: rgba(255, 255, 255, 0.15);
            }
        }

        .count_icon span {
            width: 60px;
            display: inline-block;
            height: 60px;
            background: hsla(0, 0%, 100%, .1);
            border-radius: 50%;
            text-align: center;
            line-height: 60px;
        }

        .count_title_w_n {
            padding-left: 15px;
        }

        .count_number {
            display: block;
            font-size: 22px;
            font-weight: 600;
        }

        .count_title {
            font-size: 20px;
            text-transform: capitalize;
            line-height: 1;
        }

        .row .col-sm-3 {
            padding-left: 6px;
            padding-right: 6px;
        }

        .row {
            margin-left: -6px;
            margin-right: -6px;
        }
    }

    .fixloader.member_filter_list_loader {
        align-items: flex-start;
        padding-top: 200px;
    }

    .member_filter_list_more_loader {
        align-items: flex-end;
        padding-bottom: 150px;
    }

    .create_meeting_btn {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.12) !important;
        color: #ffffff !important;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;

        @media only screen and (max-width:767px) {
            font-size: 16px;
            padding: 5px 6px;
            margin-right: 8px !important;
            min-width: 75px;
        }
    }

    @media only screen and (max-width:767px) {
        .deleted_meeting_tooltip_box {
            font-size: 16px;
        }
    }

    .user_list_name span:last-child i {
        display: none;
    }
}

@media only screen and (max-width:1345px) {
    .create_meeting_wrp {
        .table thead th.member_name {
            width: 30%;
        }

        .table thead th.member_organization {
            width: 15%;
        }

        .user_event_info .btn-primary {
            padding: 7px 10px;
        }

        .table .btn-success.member_user_video_call_btn {
            padding: 7px 10px;
        }
    }
}

.users_tooltip_wrp {
    position: relative;
    cursor: pointer;

    .users_tooltip_list {
        right: auto;
        position: absolute;
        background: #ffdee3;
        width: 200px;
        padding: 5px 15px;
        cursor: default;
        z-index: 999;
        border-radius: 0;
        font-weight: 600;
        line-height: 1.4;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 16px;
        color: #000;
        top: calc(100% + 3px);
        border-radius: 2px;
        text-align: left;
        display: none;
        left: -100px;
        z-index: 1000;
        margin: 0px;

        @media only screen and (max-width:767px) {
            left: -15px;
        }

        &:before {
            border: solid;
            border-color: #ffdee3 transparent;
            border-width: 12px 12px 0px 0px;
            top: -6px;
            content: "";
            display: block;
            right: auto;
            position: absolute;
            z-index: 1000;
            -webkit-transform: rotate(135deg);
            -moz-transform: rotate(135deg);
            transform: rotate(45deg);
            left: 50%;

            @media only screen and (max-width:767px) {
                left: 15px;
                top: -5px;
            }
        }
    }

    &:hover .users_tooltip_list {
        display: block;
    }
}

.meeting_topic {
    position: relative;
    padding-right: 35px !important;
    color: #ffec94 !important;
}

.meeting_edit_icon {
    font-size: 22px;
    color: gold;
    flex: 0 0 38px;
    width: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    background: transparent;
    border: 1px solid transparent;
    border-radius: 10px;
    cursor: pointer;
    &:hover{
        background: rgba(255, 255, 255, 0.09);
        border-color: rgba(255, 255, 255, 0.08);
        transform: translateY(-1px);
        transition: color 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease, -webkit-transform 0.18s ease;
        .fa{
            color: #87cefa !important;
        }
    }

    &.remove_meeting_class {
        top: auto;
        bottom: 5px;

        .fa {
            color: #f14843;
        }
    }
}

// .create_meeting_wrp .table tbody tr:hover > td >  .meeting_edit_icon{display:block;}
.meeting_main_table.create_meeting_table_list {
    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;

        &:hover {
            color: #000 !important;
            background: #87cefa;
        }
    }

    .meeting_list_body_wrp {
        background: none !important;
        padding: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        display: flex;
        flex: 0 0 100%;
        flex-direction: column-reverse;

        .meeting_list_table {
            display: flex;
            flex-direction: column;
            width: 100%;
            // flex: 0 0 100%;
        }
    }

    tr {
        display: flex;
        width: 100%;
        margin-bottom: 3px;
        // flex: 0 0 100%;
    }
}

.fixloader.meeting_list_loader {
    align-items: flex-end;
}

.copied_url_btn_wrp {
    .btn {
        padding: 7px;
        font-size: 16px;
        height: auto;
        line-height: 1;
        min-width: 72px;
        letter-spacing: 0.3px;

        &.btn-primary {
            color: #ffc107 !important;
            cursor: pointer;
            position: relative;
            min-width: 95px;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            outline: none !important;
            background: rgba(255, 255, 255, 0.12) !important;
            border: none;
            border-radius: 3px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 18px;

            &:hover {
                background: #87cefa !important;
                color: #000 !important;
                border-color: #87cefa !important;
            }

            &:before {
                content: '';
                display: none;
                position: absolute;
                z-index: 9998;
                top: 31px;
                left: 30px;
                width: 0;
                height: 0;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-bottom: 5px solid #87cefa;
            }

            &:after {
                content: 'Copy to Clipboard';
                display: none;
                position: absolute;
                z-index: 9999;
                top: 36px;
                left: -22px;
                width: 114px;
                height: 30px;
                color: #000;
                font-size: 13px;
                line-height: 30px;
                text-align: center;
                background: #87cefa;
                border-radius: 3px;
            }

            &:hover {
                background-color: #eee;

                &:before,
                &:after {
                    display: block;
                }
            }

            &:active,
            &:focus {
                outline: none;

                &:after {
                    content: 'Copied!';
                }
            }
        }
    }
}

.copied_url_btn_wrp {
    position: relative;

    .fa-bell {
        position: absolute;
        right: -20px;
        font-size: 20px;
        top: 26px;
        color: #f02b26;
        cursor: pointer;

        &:hover {
            color: #ffc107;
        }
    }
}

.filter_field_form {
    @media only screen and (max-width:767px) {
        margin-bottom: 10px;
    }

    .custom_select_dropdown {
        .form_control {
            font-size: 18px;
            color: #fff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            border: none;
            height: 40px;
            width: 100%;
            line-height: 36px;
            background-color: transparent;
            border: 3px solid rgba(255, 255, 255, 0.15);
            border-radius: 40px;
            cursor: pointer;
        }

        .dropdown-menu {
            height: auto !important;
            overflow-y: auto;
            background: #000000;
            border: none;
            margin: 0;
            right: 15px;
            left: 15px !important;
            padding: 0px;

            ul {
                margin: 0px;

                li {
                    padding: 3px 10px;
                    color: #ffc107;

                    &:hover {
                        background: #ffc107 !important;
                        color: #000000 !important;
                    }
                }
            }
        }

        &.show {
            .form_control {
                border-color: #ffc107;
            }
        }
    }
}

.btn-danger {
    background: rgba(255, 18, 18, 0.5) !important;
    color: #fffcc4 !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 3px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    font-size: 18px;
    letter-spacing: 0;

    &:hover {
        background: #ffe738 !important;
        color: #000 !important;
    }
}

.deleted_meeting_tooltip_box {
    position: relative;

    &:hover .deleted_meeting_tooltip {
        display: block;
    }

    .deleted_meeting_tooltip {
        right: auto;
        position: absolute;
        background: #b41818;
        width: 95px;
        padding: 2px 5px;
        cursor: default;
        border-radius: 0;
        font-weight: normal;
        line-height: 1.4;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 16px;
        color: #fff;
        top: calc(100% + 7px);
        border-radius: 2px;
        display: none;
        left: -35px;
        z-index: 10;
        margin: 0px;
        text-align: center;

        &::before {
            border: solid;
            border-color: #b41818 transparent;
            border-width: 12px 12px 0px 0px;
            top: -4px;
            content: "";
            display: block;
            right: auto;
            position: absolute;
            z-index: 1000;
            -webkit-transform: rotate(135deg);
            transform: rotate(45deg);
            left: 50px;
        }
    }
}

@media only screen and (max-width:1023px) {
    .mbl_table_list_view {
        padding-top: 15px;

        .table_list_item {
            .card {
                &.table_item_card {
                    margin-bottom: 10px;
                    padding: 10px;
                    letter-spacing: 0.5px;
                    background: rgba(228, 233, 237, 0.11);

                    .mbl_meeting_topic {
                        font-size: 20px;
                        font-weight: 500;
                        color: #ffd400;
                        text-transform: capitalize;
                        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
                        margin-bottom: 5px;
                    }

                    .time_of_estimation {
                        font-size: 18px;
                        font-weight: normal;
                    }

                    .mbl_meeting_date {
                        margin: 8px 0px 0px;
                        font-weight: normal;
                        font-size: 18px;
                    }

                    .mbl_meeting_speaker {
                        margin: 0px;
                        font-weight: normal;

                        .speaker_popup_link {
                            font-size: 18px;
                        }

                        .speaker_org {
                            font-size: 18px;
                            margin-top: 5px;
                        }
                    }

                    .btn-secondary {
                        padding: 5px 5px 6px;
                        line-height: 1;
                        font-size: 16px;
                        border-radius: 3px;
                    }

                    .member_user_video_call_btn {
                        padding: 5px;
                        font-size: 18px;
                        border-radius: 3px;
                        background: rgba(255, 255, 255, 0.12);
                        color: #ffd400;
                        border: none;
                        margin-right: 0px;
                        text-transform: capitalize;
                        font-weight: 400;
                        letter-spacing: .03em;
                        line-height: 1;
                        -webkit-box-shadow: none !important;
                        box-shadow: none !important;
                        min-width: 36px;
                        height: 34px;

                        &:disabled {
                            cursor: not-allowed;
                            opacity: .6;
                        }
                    }

                    .js-timeout {
                        font-size: 18px;
                    }

                    .webinar_topic_edit_icon {
                        .fa {
                            font-size: 24px;
                            margin-top: 3px;
                            color: #ffd700;
                        }
                    }

                    .copied_url_btn_wrp .fa-bell {
                        top: 4px;
                        right: auto;
                        left: -18px;
                    }
                }
            }
        }
    }
}

@media only screen and (min-width:768px) and (max-width:1310px) {

    .filter_field_form .custom_select_dropdown .form_control,
    .create_meeting_wrp .create_meeting_btn,
    .deleted_meeting_tooltip_box {
        font-size: 16px;
    }
}
</style>